import { render, staticRenderFns } from "./ed-homework-type-object.vue?vue&type=template&id=88c6a7ea&"
import script from "./ed-homework-type-object.ts?vue&type=script&lang=ts&"
export * from "./ed-homework-type-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-homework-type-object.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports